<template>
  <span v-if="!size['x-small'] && !compact && textButton">
    <v-btn
      v-bind="size"
      @click="showHelp"
      :color="color !== '' ? color : (textButton ? 'primary' : '')"
      :outlined="textButton || !textButton && outlined"
    >
      View Help
    </v-btn>
  </span>
  <span v-else>
    <v-btn
      size="small"
      @click="showHelp"
      :icon="!textButton"
      :color="color !== '' ? color : (textButton ? 'primary' : '')"
      :outlined="textButton || !textButton && outlined"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" size="x-large">{{ !textButton && !outlined ? 'help_outline' : 'mdi-help' }}</v-icon>
        </template>
        <span>View Help</span>
      </v-tooltip>
    </v-btn>
  </span>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "HelpButton",
    props: {
      helpTopicKey: {
        type: String,
        required: true
      },
      color: {
        type: String,
        required: false,
        default: ''
      },
      textButton: {
        type: Boolean,
        required: false,
        default: false
      },
      outlined: {
        type: Boolean,
        required: false,
        default: false
      },
      compact: {
        type: Boolean,
        required: false,
        default: false,
      },
      xSmall: {
        type: Boolean,
        required: false,
        default: false,
      },
      small: {
        type: Boolean,
        required: false,
        default: false,
      },
      medium: {
        type: Boolean,
        required: false,
        default: false,
      },
      large: {
        type: Boolean,
        required: false,
        default: false,
      },
      xLarge: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {

      };
    },
    computed: {
      size() {
        switch (true) {
          case this.xSmall:
            return {'x-small': true}
          case this.small:
            return {'small': true}
          case this.medium:
            return {'medium': true}
          case this.large:
            return {'large': true}
          case this.xLarge:
            return {'x-large': true}
          default:
            let size = { xs: "x-small", sm: "small", lg: "medium", xl: "medium" }[
              this.$vuetify.breakpoint.name
            ];
            return size && (this.textButton && !size['x-small']) ? { [size]: true } : {};
        }
      }
    },
    methods: {
      ...mapActions([
        "setIsViewingHelp",
        "setTempHelpTopicKey",
      ]),
      showHelp() {
        this.setTempHelpTopicKey(this.helpTopicKey)
        this.setIsViewingHelp(true);
      }
    }
  };
</script>
